import { Degree } from '@/models/Degree';
import { IGetters } from './interfaces/IGetters';
import { IState } from './interfaces/IState';
import { Organisation } from '@/models/Organisation';

export class Getters implements IGetters {
	private readonly state: IState;

	public constructor(state: IState) {
		this.state = state;
	}

	public getDegree(): Degree {
		return this.state.degree;
	}

	public getOrganisations(): readonly Organisation[] {
		return this.state.organisations;
	}

	public getTotalSearchResults(): number | undefined {
		return this.state.totalSearchResults;
	}

	public getCurrentPageNumber(): number {
		return this.state.currentPage;
	}
}
